import { Campaign } from '__generated__/queries-newsletter';
import { NewsletterSectionConfig } from '../Sections';
import { emptySection } from './emptyTypes';

export const buildReducerState = (campaign: Campaign, pathname: string) => {
  const parsedNewsletterSectionConfig: NewsletterSectionConfig[] | null =
    campaign &&
    campaign.newsletter?.isFromNlf &&
    campaign.newsletter &&
    campaign.newsletter.sections
      ? JSON.parse(campaign.newsletter.sections)
      : null;

  const isNewCampaign = pathname.split('/')[2] === 'new';

  if (
    isNewCampaign &&
    parsedNewsletterSectionConfig &&
    !campaign.sections.length
  ) {
    return parsedNewsletterSectionConfig.map((sectionConfig, i) =>
      emptySection(i, sectionConfig.sectionResourceCount),
    );
  }

  if (parsedNewsletterSectionConfig && campaign.sections.length) {
    return campaign.sections.map(({ ...rest }, i) => ({
      maxBlocksAmount: parsedNewsletterSectionConfig[i]?.sectionResourceCount,
      ...rest,
    }));
  }

  return campaign.sections.map(({ ...rest }) => ({
    maxBlocksAmount: undefined,
    ...rest,
  }));
};
